// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6648":"c2e02cbcae6293ac","8879":"1430061166dd2e89"}[chunkId] + ".css";
};